import PhotoSwipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
import Swiper from "swiper";
import {Tracking} from "../../tracking/tracking";
import PinitComponent from "../pinitComponent";

declare const c: {
  revealPopup: (selector: string) => void
};

declare const photoSwipeItems: [{src: string; title: string; w: number; h: number}] | undefined;

/**
 * Swiper Produktseiten
 */
export class ProductSwiper {
  private static openPhotoSwipe(selectedIndex) {
    const pswpElement = document.querySelectorAll<HTMLElement>(".pswp")[0];

    if (typeof selectedIndex !== "number") {
      selectedIndex = 0;
    }

    const options = Object.assign({}, photoSwipeOptions, {index: selectedIndex});

    if (photoSwipeItems !== undefined) {
      const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, photoSwipeItems, options);
      gallery.init();
    }
  }

  private readonly productSwiper: Swiper;
  private zoomSwiper: Swiper;

  constructor(swiperDiv: Element, zoomAnchorList: HTMLCollectionOf<Element>) {
    this.productSwiper = new Swiper(swiperDiv, paramsProduct);
    this.productSwiper.loaded = true;
    this.initZoomHandlers(zoomAnchorList);
  }

  private initZoomHandlers(zoomAnchorList: HTMLCollectionOf<Element>) {
    Array.from(zoomAnchorList).forEach((zoomAnchor) => {
      zoomAnchor.addEventListener("click", (evt) => {
        evt.preventDefault();

        const initialSlide = this.productSwiper.realIndex;
        if (window.matchMedia("(max-width:480px)").matches) {
          ProductSwiper.openPhotoSwipe(initialSlide);

          return;
        }
        c.revealPopup("#GalleryPopup");

        if (typeof this.zoomSwiper === "undefined") {
          const params = Object.assign({}, paramsZoom, {initialSlide}, paramsZoomExt);
          this.zoomSwiper = new Swiper(".swiper-container-product-zoom", params);
          this.zoomSwiper.loaded = true;
        }
        if (typeof this.zoomSwiper.slideToLoop === "function" && parent !== null) {
          this.zoomSwiper.slideToLoop(initialSlide);
        }
      });
    });
  }
}

// Params for products swiper
const paramsProduct = {
  lazy: {
    loadPrevNext: true,
  },
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  on: {
    init,
    slideChange,
  },
  pagination: {
    clickable: true,
    el: ".swiper-pagination",
    type: "bullets",
  },
  preloadImages: false,
  simulateTouch: false,
  spaceBetween: 5,
};

// Params for zoom swiper, also used for outlet swiper
export const paramsZoom = {
  lazy: {
    loadPrevNext: true,
  },
  navigation: {
    nextEl: ".swiper-button-next-zoom",
    prevEl: ".swiper-button-prev-zoom",
  },
  on: {
    lazyImageReady(slide, image) {
      PinitComponent.pinit(image, {
        minHeight: 5,
        minWidth: 5,
      });
    },
    slideChange: slideChangeZoom,
  },
  pagination: {
    clickable: true,
    el: ".swiper-pagination-zoom",
  },
  preloadImages: false,
  simulateTouch: false,
  spaceBetween: 10,
};

const photoSwipeOptions = {
  bgOpacity: 0.7,
  closeEl: false,
  hideAnimationDuration: 0,
  history: true,
  loop: false,
  showAnimationDuration: 0,
  tapToClose: true,
  tapToToggleControls: false,
};

// Params only used for zoom swiper
const paramsZoomExt = {
  loop: true,
};

function init() {
  Array.from<HTMLDivElement>(this.slides).forEach((slide) => {
    const anchor = slide.querySelector("a.gallery-zoom") as HTMLAnchorElement;
    anchor.addEventListener("click", () => {
      Tracking.sendEvent("Product.EmbeddedSwiper.Slide.Clicked");
    });
  });
}

function slideChange() {
  if (this.loaded) {
    Tracking.sendEvent("Product.EmbeddedSwiper.Swiped");
  }
}

function slideChangeZoom() {
  if (this.loaded) {
    Tracking.sendEvent("Product.FullscreenSwiper.Swiped");
  }
}
